import React from "react";
import {
  AlertCircle,
  CheckCircle,
  MinusCircle,
  Clock,
  Loader,
  CircleDashed,
  PlayCircle,
  Square,
} from "lucide-react";
import "./StatusBadge.css";

const StatusBadge = ({ status }) => {
  const getStatusStyle = (status) => {
    const normalizedStatus = status?.toLowerCase();

    switch (normalizedStatus) {
      // ----- Status -----
      case "pending":
        return { text: "Pending", className: "badge badge-pending" };
      case "in_process":
        return { text: "In Process", className: "badge badge-inprocess" };
      case "processing":
        return { text: "Processing", className: "badge badge-inprocess" };
      case "approval_pending":
        return { text: "Approval Pending", className: "badge badge-approval" };
      case "completed":
        return { text: "Completed", className: "badge badge-completed" };
      case "success":
        return { text: "Success", className: "badge badge-completed" };
      case "failed":
        return { text: "Failed", className: "badge badge-failed" };

      // ----- Disposition -----
      case "positive":
        return { text: "Positive", className: "badge badge-positive" };
      case "negative":
        return { text: "Negative", className: "badge badge-negative" };
      case "neutral":
        return { text: "Neutral", className: "badge badge-neutral" };
      case "all":
        return { text: "All", className: "badge badge-all" };

      // ----- Campaign -----
      case "start":
        return { text: "Started", className: "badge badge-start" };
      case "stop":
        return { text: "Stopped", className: "badge badge-stop" };
      case "running":
        return { text: "Running", className: "badge badge-running" };

      // Default
      default:
        return { text: status, className: "badge badge-default" };
    }
  };

  const { text, className } = getStatusStyle(status);

  return (
    <span className={className}>
      {/* Status icons */}
      {status?.toLowerCase() === "failed" && <AlertCircle size={14} className="icon" />}
      {status?.toLowerCase() === "completed" && <CheckCircle size={14} className="icon" />}
      {status?.toLowerCase() === "success" && <CheckCircle size={14} className="icon" />}

      {/* Disposition icons */}
      {status?.toLowerCase() === "positive" && <CheckCircle size={14} className="icon" />}
      {status?.toLowerCase() === "negative" && <MinusCircle size={14} className="icon" />}
      {status?.toLowerCase() === "neutral" && <CircleDashed size={14} className="icon" />}

      {/* Common statuses */}
      {status?.toLowerCase() === "pending" && <Clock size={14} className="icon" />}
      {status?.toLowerCase() === "in_process" && <Loader size={14} className="icon spin" />}
      {status?.toLowerCase() === "processing" && <Loader size={14} className="icon spin" />}

      {/* Campaign statuses */}
      {status?.toLowerCase() === "start" && <PlayCircle size={14} className="icon" />}
      {status?.toLowerCase() === "stop" && <Square size={14} className="icon" />}
      {status?.toLowerCase() === "running" && <Loader size={14} className="icon spin" />}

      {text}
    </span>
  );
};

export default StatusBadge;
